module.exports = __webpack_public_path__ + "img/lago-nabor.ea083d84.png";